module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-152x152-4a8ea316e0a9f88ba951d3386f809f1d.png";